import React from "react";
import "../Styles/KgreatProjectPic.css";
import ClinicRemodelling from "../Components/Assets/ClinicRen/CR1.png";
import ClinicRemodelling1 from "../Components/Assets/ClinicRen/CR1.png";
import ClinicRemodelling2 from "../Components/Assets/ClinicRen/CR2.png";
import ClinicRemodelling3 from "../Components/Assets/ClinicRen/CR3.png";
import ClinicRemodelling4 from "../Components/Assets/ClinicRen/CR4.png";
import ClinicRemodelling5 from "../Components/Assets/ClinicRen/CR5.png";


const ProjPicClinicRemodelling = () => {
  return (
    <>
      <section className="sectionProjectPic">
        <div className="divProjPicLanding">
          <div className="divProjectsImage">
            <img
              alt="ProjectPicture"
              src={ClinicRemodelling}
              className="projectsLandingImage"
            />
          </div>
          <div className="divImageText">
            <h1 className="headingImage">CLINIC REMODELLING</h1>
            <h1 className="headingImage1">ABUJA</h1>
            <p className="textOfImage">CONTRACTING</p>
          </div>
        </div>

        {/* <div className="divProjPictTextOf">
          <p className="aboutProject">
            <span>PROJECT:</span> : PROPOSED RESIDENTIAL DEVELOPMENT FOR
            LEVITIKAL GROUP AT OKO-AWO STREET, VICTORIA ISLAND, LAGOS.
          </p>
          <p className="aboutProject">
            <span>BUILDING TYPE:</span>
            MIXED TYPED RESIDENTIAL AND OFFICE BUILDING ON 23 FLOORS.
          </p>
          <p className="aboutProject">
            <span>STATUS: </span>
            ONGOING
          </p>
          <p className="aboutProject">
            We were engaged to provide MEP consultancy & Installation services
            for a mixed typed residential and office building on 23 floors. The
            architectural design was carefully studied and state of the art and
            modern applications in the MEP industry was utilized for the design
            of the building. <br />
            The plumbing services recommended for the building utlizes the top
            range obatainable in the industry, Electrical system put into
            consideration energy saving options for lighting and power
            generation, and the Air conditioning was carefully thought out and
            design to meet industry energy efficiency standards.
          </p>
        </div> */}

        <div className="divProjPicMain">
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={ClinicRemodelling1} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={ClinicRemodelling2} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={ClinicRemodelling3} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={ClinicRemodelling4} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={ClinicRemodelling5} className="projPicImageOf" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjPicClinicRemodelling;
